/** Component modified from: https://stackoverflow.com/a/59154855/9101294 */
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

const Portal = (props) => {
    const [element, setElement] = useState(undefined)

    useEffect(() => {
        if (typeof(document) !== 'undefined') {
            const element = document.createElement('div')
            document.body.appendChild(element)
            setElement(element)
            return () => document.body.removeChild(element)
        }
    }, [])

    useEffect(() => updateProps(props, element), [props, element])

    const updateProps = (props, element) => {
        if (element) {
            if (props.id)
                element.id = props.id
            if (props.className)
                element.className = props.className
            if (props.onMouseLeave)
                element.onmouseleave = props.onMouseLeave
            if (props.style) {
                Object.keys(props.style).forEach(key => {
                    element.style[key] = props.style[key]
                })
            }
        }
    }

    return element ? ReactDOM.createPortal(props.children, element) : null
}

export default Portal